import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=aedf771e&scoped=true&"
import script from "./BookPage.vue?vue&type=script&lang=js&"
export * from "./BookPage.vue?vue&type=script&lang=js&"
import style0 from "./BookPage.vue?vue&type=style&index=0&id=aedf771e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedf771e",
  null
  
)

export default component.exports